import React from 'react';
import ReactDOM from 'react-dom';
import '../../utils/global';
import 'normalize.css';
import App from './App';
import './index.less';
import {Provider} from 'react-redux'
import configureStore from "./configureStore";


const store = configureStore();

ReactDOM.render(<Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/apps/portfolio/index.js